var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state == 1
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("save-as")))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.bookYearItems,
                          label: _vm.$ct("to-bookyear"),
                        },
                        model: {
                          value: _vm.data.toBookYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "toBookYear", $$v)
                          },
                          expression: "data.toBookYear",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.saleTypeItems,
                          label: _vm.$ct("save-as"),
                        },
                        model: {
                          value: _vm.data.saveAsTypeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "saveAsTypeId", $$v)
                          },
                          expression: "data.saveAsTypeId",
                        },
                      }),
                      _c(
                        "app-error-message",
                        { attrs: { hide: _vm.saveAsTypeIdError == "" } },
                        [_vm._v(_vm._s(_vm.$ct(_vm.saveAsTypeIdError)))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-journal", {
                        attrs: {
                          label: _vm.$ct("journal"),
                          "no-journal-option": "",
                        },
                        model: {
                          value: _vm.data.toJournalId,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "toJournalId", $$v)
                          },
                          expression: "data.toJournalId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("save-as-1-document") },
                        model: {
                          value: _vm.data.saveAs1Document,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "saveAs1Document", $$v)
                          },
                          expression: "data.saveAs1Document",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("delete-original-documents"),
                          disabled: !_vm.hasDeletePermissions,
                        },
                        model: {
                          value: _vm.data.deleteOriginalDocuments,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "deleteOriginalDocuments", $$v)
                          },
                          expression: "data.deleteOriginalDocuments",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("compute-stock") },
                        model: {
                          value: _vm.data.computeStock,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "computeStock", $$v)
                          },
                          expression: "data.computeStock",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          disabled: !_vm.data.computeStock,
                          label: _vm.$ct("create-negative-stock-ins"),
                        },
                        model: {
                          value: _vm.data.createNegativeStockIns,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "createNegativeStockIns", $$v)
                          },
                          expression: "data.createNegativeStockIns",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("make-negative") },
                        model: {
                          value: _vm.data.makeNegative,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "makeNegative", $$v)
                          },
                          expression: "data.makeNegative",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("add-imported-from-sale-text"),
                        },
                        model: {
                          value: _vm.data.addImportedFromSaleText,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "addImportedFromSaleText", $$v)
                          },
                          expression: "data.addImportedFromSaleText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          disabled: _vm.useTodaysDateDisabled,
                          label: _vm.$ct("set-new-documents-to-todays-date"),
                        },
                        model: {
                          value: _vm.data.useTodaysDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "useTodaysDate", $$v)
                          },
                          expression: "data.useTodaysDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          disabled: _vm.keepSameNumbersDisabled,
                          label: _vm.$ct("keep-same-numbers"),
                        },
                        model: {
                          value: _vm.data.keepSameNumbers,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "keepSameNumbers", $$v)
                          },
                          expression: "data.keepSameNumbers",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: !_vm.isValid || _vm.isSubmitting,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm.state == 2
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("save-as")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("date") },
                        model: {
                          value: _vm.data.beginDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "beginDate", $$v)
                          },
                          expression: "data.beginDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-contact-search", {
                        attrs: {
                          label: _vm.$ct("client"),
                          "group-id": _vm.contactGroupId,
                        },
                        model: {
                          value: _vm.contact,
                          callback: function ($$v) {
                            _vm.contact = $$v
                          },
                          expression: "contact",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.vatRegimeItems,
                          label: _vm.$ct("vat-regime"),
                        },
                        model: {
                          value: _vm.data.vatRegime,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "vatRegime", $$v)
                          },
                          expression: "data.vatRegime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: !_vm.isValid || _vm.isSubmitting,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }